import React, { FC } from 'react'
import { REVIEWS_CAROUSEL } from './helpers/constants'
import styles from './ArtAdvisory.module.scss'
import DoubleQuote from 'svg/double-quote.svg'
import Carousel from 'components/SA/Carousel'

const ReviewsCarousel: FC = () => {
  return (
    <Carousel data={REVIEWS_CAROUSEL} styleOverride={styles.reviewsCarousel}>
      <>
        {REVIEWS_CAROUSEL.map((item, index) => (
          <li key={index}>
            <div className={styles.imageCol}>
              <img src={item.image} />
              <div className={styles.titleRow}>
                <DoubleQuote className={styles.quote} />
                <p className={`${styles.title} defaultTypographyH4`}>{item.title}</p>
              </div>
            </div>
            <div className={styles.textCol}>
              <DoubleQuote className={styles.quote} />
              <p className={`${styles.title} defaultTypographyH4`}>{item.title}</p>
              <p className={`${styles.description} defaultTypographyMedium`}>{item.description}</p>
              <p className={`${styles.name} defaultTypographyCtaMedium defaultTextUppercase`}>
                {item.name}
              </p>
              <p className={`${styles.artworkTitle} defaultTypographyXSmall`}>
                {item.artworkTitle}
              </p>
            </div>
          </li>
        ))}
      </>
    </Carousel>
  )
}

export default ReviewsCarousel
